// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Vrla","list":"PatternAutocomplete_list__12HTW"};